import axios from 'axios';

// ✅ On local dev (`npm start`):      reads .env              → http://localhost:5000/api
// ✅ On live build (`npm run build`): reads .env.production   → https://carrental.oriesolutions.co.in/api
const API_BASE = process.env.REACT_APP_API_URL;
const BASE     = process.env.REACT_APP_BASE_URL;
const WEBSITE_BASE_URL     = process.env.REACT_APP_WEBSITE_BASE_URL;

export const API = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const BASE_URL = BASE;
export const WEBSITE_URL = WEBSITE_BASE_URL;
